/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import InviteAccept from './layout';

import {
  authenticatedAndBrandingReady, getAccountTenants, getAvailableTenants,
  getUserEmail,
  platformViewOnlyMode,
} from '../../redux/modules/userData/selectors';
import {
  setUserAuthed,
  setUserTenants,
  togglePlatformViewOnlyMode,
  updatePlatformPermissions,
  switchTenant, setAccountTenants, setTenantsList,
} from '../../redux/modules/userData';
import { isInIframe } from 'serenova-js-utils/browser';
import { fetchBranding } from '../../redux/modules/entities/branding/actions';
import { updateUserPermissions } from '../../redux/modules/userData';

import { changeLocale } from '../../redux/modules/language';
import { selectCurrentLocale } from '../../redux/modules/language/selectors';

export function mapStateToProps(state) {
  return {
    accountTenants: getAccountTenants(state),
    availableTenants: getAvailableTenants(state),
    getUserEmail: getUserEmail(state),
    hasStarted: authenticatedAndBrandingReady(state),
    insideIframe: !isInIframe(),
    locale: selectCurrentLocale(state),
    platformViewOnlyMode: platformViewOnlyMode(state),
  };
}

export const actions = {
  changeLocale,
  fetchBranding,
  setAccountTenants,
  setTenantsList,
  setUserAuthed,
  setUserTenants,
  switchTenant,
  togglePlatformViewOnlyMode,
  updatePlatformPermissions,
  updateUserPermissions,
};

export default connect(mapStateToProps, actions)(InviteAccept);
